import React, { Dispatch, memo, SetStateAction } from "react";

import NonLabMacroFilter, {
  INonLabFilterParams,
} from "../NonLabShared/NonLabMacroFilter";

interface IMacroFilterProps {
  onFilterParams: Dispatch<SetStateAction<IFilterParams>>;
  filterParams: IFilterParams;
}

export interface IFilterParams extends INonLabFilterParams {
  individualDocument: string;
}

const translationPath = "page.4uBus.logs.tasyToTasyNonLabExamsAvailable.";

const MacroFilter: React.FC<IMacroFilterProps> = (props) => (
  <NonLabMacroFilter
    {...props}
    translationPath={translationPath}
    documentField="individualDocument"
  />
);

export default memo(MacroFilter);
